import React from 'react';
import ReactDOM from 'react-dom'; //hook react app to index.html

import App from './App';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));
